import React, { useState } from 'react';
import { Modal, Button, Spinner, Container, Row, Col } from 'react-bootstrap';
import bg2 from '../../assets/bg-2.svg';
import boxImg from '../../assets/box-img.webp';
import EmailService from "../../service/EmailService";
import logo from '../../assets/logo.webp';

const Footer = () => {

  const [formData, setFormData] = useState({
    name: 'Newsletter Subscription',
    email: '',
    phone: '0000000000',
    formMessage: '',
  });
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    const currentTimestamp = new Date().toISOString();
    const subscriptionMessage = `Newsletter subscription request from Towing411 at : ${currentTimestamp}`;

    try {
      const response = await EmailService.sendEmail({ ...formData, formMessage: subscriptionMessage });
      setMessage({ text: response, variant: 'success' });
      setFormData({ name: 'Newsletter Subscription', email: '', phone: '0000000000', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (<>

    <section className='footer_callAction top-zebra-border'>
      <div className='bg-towing'>
        <h4>Towing 411</h4>
      </div>
      <div className='container'>
        <div className='row justify-content-between align-items-center'>
          <div className='col-lg-5 col-md-6'>
           <div className='callAction_content'>
            <h4>Call Us For Towing 411 and put your timer on!</h4>
            <p>Our offices are always open. You can also call us to talk
              to our roadside experts. Get a free quote today!</p>
           </div>
          </div>

          <div className='col-lg-4 col-md-5'>
           <div className='callAction_number'>
            <h4><i class="fas fa-phone"></i> Call us Today!</h4>
            <h5>+1 (800) 805-7820</h5>
           </div>
          </div>

        </div>
      </div>
    </section>

    <footer className="text-white top-zebra-border">
      <Container>

      {/*  <Row>
        <form onSubmit={handleSubmit}>
           <div className="row justify-content-center news_letter_row align-items-center">
            <div className='col-md-5'>
              <div className='news_title'>
              <h4>Subscribe to our newsletter!</h4>
              <p>Let me know if you'd like to tweak it further!</p>
              </div>
            </div>

            <div className="col-md-4 px-md-0 px-3">
              <div className="form-group news_input mb-0">
                 <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                  disabled={loading}
                  />
              </div>
            </div>

            <div className="col-md-2 px-md-0 px-3">
                 <button type="submit" className="btn news_btn" disabled={loading}>
                     {loading ? (
                        <>
                           <Spinner animation="border" size="sm" role="status" className="me-2" />
                           Subscribe
                        </>
                     ) : (
                        'Subscribe'
                     )}
                  </button>
            </div>
           </div>
           </form>
          </Row>  */}


          <Row className='justify-content-between'>
          <Col className='social-icon my-md-5 my-3 text-left' lg={3} md={6}>
          <img className='f-logo' src={logo} alt="towing-411"/>
          <p className='text-left'>Towing 411 is the leading platform to connect you with reputable and
            reliable towing or roadside service providers in your area.</p>
          <ul>
          <li><a href="https://www.facebook.com/towing411/" target="_blank"><i className="fab fa-facebook-square" title="facebook"></i></a></li>
          <li><a href="https://www.instagram.com/towing411_/" target="_blank"><i className="fab fa-instagram" title="instagram"></i></a></li>
          <li><a href="https://www.pinterest.com/towing411_/" target="_blank"><i className="fab fa-pinterest" title="pinterest"></i></a></li>
          <li><a href="https://www.youtube.com/@towing411" target="_blank"><i className="fab fa-youtube" title="youtube"></i></a></li>
          <li><a href="https://x.com/towing411_" target="_blank"><i className="fab fa-x-twitter" title="twitter"></i></a></li>
          </ul>
          </Col>

          <Col className='foot_text my-md-5 my-2' lg={2} md={6}>
            <h4>Company <strong>Links</strong></h4>
            <ul>
              <li><a href="/" className="text-white"><i class="fas fa-angle-right"></i> Home</a></li>
              <li><a href="/plans" className="text-white"><i class="fas fa-angle-right"></i> Plans</a></li>
              <li><a href="/about" className="text-white"><i class="fas fa-angle-right"></i> About Us</a></li>
              <li><a href="/contact" className="text-white"><i class="fas fa-angle-right"></i> Contact Us</a></li>
            </ul>
          </Col>

          <Col className='foot_text my-md-5 my-2' lg={2} md={6}>
            <h4>Useful <strong>Links</strong></h4>
            <ul>
              <li><a href="/blogs" className="text-white"><i class="fas fa-angle-right"></i> Blog</a></li>
              <li><a href="/privacypolicy" className="text-white"><i class="fas fa-angle-right"></i> Privacy Policy</a></li>
              <li><a href="/termsandcondition" className="text-white"><i class="fas fa-angle-right"></i> Terms & Conditions</a></li>
              <li><a href="/refundandcancellation" className="text-white"><i class="fas fa-angle-right"></i> Refund & Cancellation</a></li>
            </ul>
          </Col>

          <Col className='contact-detail my-md-5 my-2' lg={3} md={6}>
          <h4>Get in <strong>Touch</strong></h4>
          <ul className="contact-list">
            <li><a href="tel:+18008057820"><i className="fa fa-phone" title="Phone"></i> +1 (800) 805-7820</a></li>
            <li><a href="mailto:contact@towing411.net"><i className="fa fa-envelope" title="Email"></i> contact@towing411.net</a></li>
          </ul>
          </Col>


          <Col md={12}>
          <hr/>
          </Col>

          <Col md={12} className="text-center mt-2 copy-right">
            <p>&copy; 2022- {new Date().getFullYear()} Towing 411. All Rights Reserved. Powered by Breakdown Inc</p>
          </Col>

        </Row>

      </Container>
    </footer>

    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className='py-2' closeButton>
          <Modal.Title><strong>{message.variant === 'success' ? 'Subscribed Successfully!' : 'Error'}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center my-md-3">
          {message.variant === 'success' ? (
            <>
              <p className="text-success mb-0">😊 Thank you for subscribing! </p>
            </>
          ) : (
            <>
              <p className="text-danger mb-0">❌ {message.text}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;
